import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {PagedResponseDTO} from 'src/app/modules/common/models/PagedResponseDTO';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {NationalDrugDTO} from 'src/app/modules/pbm/models/NationalDrugDTO';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NationalDrugService {

  private url = environment.baseUrl + '/national-drug';

  constructor(private httpClient: HttpClient) {
  }

  getListOfNationalDrugs(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<NationalDrugDTO>> {
    return this.httpClient.post<PagedResponseDTO<NationalDrugDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveNationalDrug(nationalDrugDTO: NationalDrugDTO): Observable<NationalDrugDTO> {
    return this.httpClient.post<NationalDrugDTO>(this.url, nationalDrugDTO);
  }

  deleteNationalDrug(nationalDrugId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + nationalDrugId);
  }

  getNationalDrug(nationalDrugId: number): Observable<NationalDrugDTO> {
    return this.httpClient.get<NationalDrugDTO>(this.url + '/' + nationalDrugId);
  }

}
